import React from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Tiny floating build-version badge.
 *
 * Renders ONLY inside the Capacitor APK (Android / iOS native shell).
 * The web app at crm.zartecsolutions.com doesn't need it — admins can
 * always check the version via the network tab or the login footer.
 * Inside the APK, however, this badge is invaluable for diagnosing
 * "is my device on the latest deploy?" without forcing the user to
 * navigate to /m/home.
 *
 * Positioned bottom-right, semi-transparent, non-interactive — easy to
 * ignore until you need it.
 *
 * The timestamp is baked into the JS bundle at craco build time via
 * webpack DefinePlugin (see craco.config.js → REACT_APP_BUILD_TIME).
 */
const BuildStampBadge = () => {
  if (!Capacitor?.isNativePlatform?.()) return null;
  const stamp = process.env.REACT_APP_BUILD_TIME || 'dev';
  // Trim millis + Z for compactness: 2026-06-27T08:05:01.355Z → 27/06 08:05
  let short = stamp;
  const m = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(stamp);
  if (m) short = `${m[3]}/${m[2]} ${m[4]}:${m[5]}`;
  return (
    <div
      data-testid="build-stamp-badge"
      style={{
        position: 'fixed',
        bottom: 4,
        right: 6,
        zIndex: 9999,
        pointerEvents: 'none',
        fontSize: 9,
        lineHeight: 1.2,
        color: 'rgba(255,255,255,0.85)',
        background: 'rgba(15,23,42,0.55)',
        padding: '2px 6px',
        borderRadius: 4,
        fontFamily: 'ui-monospace, monospace',
      }}
      title={`Build ${stamp}`}
    >
      v{short}
    </div>
  );
};

export default BuildStampBadge;
